import request, { METHODS } from "src/utils/api-base";

const adminNotificationApis = {
  getNotificationList: (params: {
    page?: number;
    limit: number;
    unreadOnly?: boolean;
  }) => {
    return request({
      route: "/admin/notifications",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    });
  },

  getUnreadCount: () => {
    return request({
      route: "/admin/notifications/unread-count",
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    });
  },

  markNotificationRead: (_id: string) => {
    return request({
      route: `/admin/notifications/${_id}/read`,
      method: METHODS.PATCH,
      auth: true,
      isAdminAuth: true,
    });
  },

  markAllNotificationsRead: () => {
    return request({
      route: "/admin/notifications/mark-all-read",
      method: METHODS.PATCH,
      auth: true,
      isAdminAuth: true,
    });
  },
};

export default adminNotificationApis;
